import { actionKey as rootActionKey } from '../constants';
export const actionKey = `${rootActionKey}__WITH_CURSOR`;
